import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { transformFormErrors } from '../../helpers/helpers';
import Modal from '../../HOC/Modal/Modal';
import { useReportingGroupMappingOptions, useReportsSetup } from '../../hooks';
import AddNewReportForm from './AddNewReportForm/AddNewReportForm';
import { AddNewReportBodyCont } from './AddNewReportModal.styles';
import { IPostReportingGroupBody } from '../../services/reports';
import { IReportsSetupItem } from '../../services/surveys';

interface IAddNewReportModal {
  active: boolean;
  editData?: IReportsSetupItem;
  setActive: () => void;
  refreshList: () => void;
  isEffectSurvey: boolean;
}
const AddNewReportModal: FC<IAddNewReportModal> = ({
  active,
  editData,
  setActive,
  refreshList,
  isEffectSurvey,
}) => {
  const { t } = useTranslation();
  const { addNewReport, editReport } = useReportsSetup();
  const { mappingOptions } = useReportingGroupMappingOptions(active);
  const [apiError, setApiError] = useState({});

  const resetAndCloseModal = () => {
    setApiError({});
    setActive();
  };

  const submitAddReport = async (body: IPostReportingGroupBody) => {
    try {
      if (editData) {
        await editReport(editData.id, {
          name: body.name,
          mappedDepartment: body.mappedDepartment,
        });
        refreshList();
        resetAndCloseModal();
        return;
      }

      await addNewReport(body);
      refreshList();
      resetAndCloseModal();
    } catch (e) {
      const {
        data: { details },
      } = e;
      const errorData = transformFormErrors(details);
      setApiError(errorData);
    }
  };

  const clickSave = () => {
    const applyButton = document.getElementById('AddReportModalCallToAction');
    applyButton?.click();
  };
  return (
    <Modal
      active={active}
      title={
        editData
          ? t('viewSurvey.reportsSetup.modals.edit.title')
          : t('viewSurvey.reportsSetup.modals.create.title')
      }
      callToAction={clickSave}
      closeModal={resetAndCloseModal}
      buttonNames={{
        action: t('viewSurvey.reportsSetup.modals.create.save'),
        cancel: t('viewSurvey.reportsSetup.modals.create.cancel'),
      }}
      top="150px"
      width={isEffectSurvey ? '400px' : '800px'}
    >
      <AddNewReportBodyCont id="AddNewReportBodyCont">
        <AddNewReportForm
          submit={submitAddReport}
          apiError={apiError}
          editData={editData}
          isEffectSurvey={isEffectSurvey}
          mappingOptions={mappingOptions}
        />
      </AddNewReportBodyCont>
    </Modal>
  );
};

export default AddNewReportModal;
